import React, { lazy, Suspense } from "react";

import FixNavigate from "../components/common/FixNavigate";
import LoadingComponent from "../components/common/loading/loading.component";
import SiteHumanClonePage from "../components/site/home/site-human-clone-page.component";
import BlogPage from "../pages/site/blog.page";
import ErrorPage from "../pages/site/ErrorPage";
import FrequentlyAskedQuestionsPage from "../pages/site/frequently-asked-questions.page";
import Home from "../pages/site/Home";

const Plans = lazy(() => import("../pages/site/Plans"));
const Contact = lazy(() => import("../pages/site/Contact"));
const TermsOfServicePage = lazy(
  () => import("../pages/site/terms-of-service.page")
);

const SiteRouteChildren = [
  {
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "plans",
        element: (
          <Suspense fallback={<LoadingComponent />}>
            <Plans />{" "}
          </Suspense>
        )
      },
      {
        path: "frequently-asked-questions",
        element: (
          <Suspense fallback={<LoadingComponent />}>
            <FrequentlyAskedQuestionsPage />
          </Suspense>
        )
      },
      {
        path: "blog/:id",
        element: (
          <Suspense fallback={<LoadingComponent />}>
            <BlogPage />
          </Suspense>
        )
      },
      {
        path: "human-clone-page",
        element: (
          <Suspense fallback={<LoadingComponent />}>
            <SiteHumanClonePage />
          </Suspense>
        )
      },
      {
        path: "terms-of-service",
        element: (
          <Suspense fallback={<LoadingComponent />}>
            <TermsOfServicePage />
          </Suspense>
        )
      },
      {
        path: "contact-us",
        element: (
          <Suspense fallback={<LoadingComponent />}>
            <Contact />
          </Suspense>
        )
      }
    ]
  }
];

const SiteRouter = [
  {
    path: "/en-US",
    element: <FixNavigate to={"/login"} />,
    errorElement: <ErrorPage />,
    children: SiteRouteChildren
  },
  {
    path: "/fr-FR",
    element: <FixNavigate to={"/login"} />,
    errorElement: <ErrorPage />,
    children: SiteRouteChildren
  },
  {
    path: "/plans",
    element: <FixNavigate to={"/plans"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/terms-of-service",
    element: <FixNavigate to={"/plans"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/contact-us",
    element: <FixNavigate to={"/contact-us"} />,
    errorElement: <ErrorPage />
  },
  {
    path: "/frequently-asked-questions",
    element: <FixNavigate to={"/frequently-asked-questions"} />,
    errorElement: <ErrorPage />
  }
];

export default SiteRouter;
